import { LoadCompanyLogoResult, GetCompanyDataResult } from "../Interfaces/Interfaces";

// Theme
export const THEME_TOGGLE = "THEME_TOGGLE";
export const MENU_TOGGLE_COLLAPSE = "MENU_TOGGLE_COLLAPSE";
export const MENU_SET_COLLAPSE = "MENU_SET_COLLAPSE";
// Auth
export const AUTH_LOGIN = "AUTH_LOGIN";
export const AUTH_LOGOUT = "AUTH_LOGOUT";
export const REFRESH_TOKENS = "REFRESH_TOKENS";
export const UPDATE_ZENDESKID = "UPDATE_ZENDESKID";
export const UPDATE_TIMEZONE = "UPDATE_TIMEZONE";
export const UPDATE_ISVALID = "UPDATE_ISVALID";

//Language
export const CHANGE_LANGUAGE = "CHANGE_LANGUAGE";
//notifications
export const ADD_NEW_MESSAGE = "ADD_NEW_MESSAGE";
export const SET_HAS_NEW_VALUE = "SET_HAS_NEW_VALUE";
export const REMOVE_MESSAGE = "REMOVE_MESSAGE";
export const REMOVE_ALL_MESSAGES = "REMOVE_ALL_MESSAGES";
//Push Notifications
export const Push_Notifications = "Push_Notifications";
export const SIGNAL_R = "SIGNAL_R";
export const CLEAR_PUSH_NOTIFICATIONS = "CLEAR_PUSH_NOTIFICATIONS";
export const IS_ENABLED = "IS_ENABLED";
export const IS_ENABLED_DESCRIPTION = "IS_ENABLED_DESCRIPTION";
export const Email_Notifications = "Email_Notifications";
//SINGAL R 
export const ADD_SIGNALR = "ADD_SIGNALR";
export const REMOVE_SIGNALR = "REMOVE_SIGNALR";
export const CHECK_SIGNALR = "CHECK_SIGNALR";
export const HANDLE_USER_CONNECTIVITY = "HANDLE_USER_CONNECTIVITY";

export const UPDATE_COMPANY_SETTINGS = "UPDATE_COMPANY_SETTINGS";
//CompanyData
export const UPDATE_COMPANY_DATA = "UPDATE_COMPANY_DATA";
interface ChangeLanguageAction {
    type: typeof CHANGE_LANGUAGE;
    payload: LanguageOption;
}

export type LanguageActionsTypes = ChangeLanguageAction;

export interface LanguageOption {
    label: string;
    value: string;
}

export interface LoginAuthAction {
    type: typeof AUTH_LOGIN;
    payload: LoginAction;
}

interface LogoutAuthAction {
    type: typeof AUTH_LOGOUT;
}

interface RefreshTokensAuthAction {
    type: typeof REFRESH_TOKENS;
    payload: IRefreshTokens;
}
export interface UpdateZendeskIDAction {
    type: typeof UPDATE_ZENDESKID;
    payload: string;
}
export interface UpdateIsValid {
    type: typeof UPDATE_ISVALID;
    payload: boolean;
}
export interface PushNotificationStatus {//TODO check imports as differnt from Action
    PNID: number;
    IsEnabled: boolean;
    PNDescription: string;
}
export interface PushNotificationStatusClass {
    PushNotificationStatus: PushNotificationStatus[];
    signalRIsConnected: boolean;
}
export interface PushNotifications {
    type: typeof Push_Notifications;
    payload: PushNotificationStatusClass;
};
export interface SignalR {
    type: typeof SIGNAL_R;
    payload: boolean;
};
export interface ADDSIGNALR {
    type: typeof ADD_SIGNALR;
    payload: any;
}
export type SignalRTypes = ADDSIGNALR | REMOVESIGNALR | CheckSignalR;
export interface REMOVESIGNALR {
    type: typeof REMOVE_SIGNALR;
}
export interface HandleUserConnectivity {
    type: typeof HANDLE_USER_CONNECTIVITY;
    payload: boolean;
}
export interface CheckSignalR {
    type: typeof CHECK_SIGNALR;
}
export interface IRefreshTokens {
    token: string;
    refreshToken: string;
}
export interface ClearPushNotifications {
    type: typeof CLEAR_PUSH_NOTIFICATIONS;
};
export type AuthActionsTypes = LoginAuthAction | LogoutAuthAction | RefreshTokensAuthAction | UpdateZendeskIDAction;



export interface PushNotificationStatus {//TODO check imports as differnt from Action
    PNID: number;
    IsEnabled: boolean;
    PNDescription: string;
}
export interface UpdateCompanySettings {
    type: typeof UPDATE_COMPANY_SETTINGS;
    payload: LoadCompanyLogoResult;
}
export interface UpdateCompanyData {
    type: typeof UPDATE_COMPANY_DATA;
    payload: GetCompanyDataResult;
}

export interface IClientPermissionSP {
    IsDemoGU: boolean;
    KYCIsApprvd: boolean;
    RequireKYC: boolean;
    IsIB: boolean;
    IsMM: boolean;
    IsTrader: boolean;
    IsActive: boolean;
    ActivationCode: string;
    IsManual: boolean;
    IsDeleted: boolean;
    IsValid: boolean;
    DeleteDate: Date;
    CreationDate: Date;
    PoolID: number;
    CategoryID: number;
    RestoreDate: Date;
    KTID: number;
    PermManageARule: boolean;
    PermManageARuleAmount: boolean;
    PermManageInvestorStatus: boolean;
    PermCloseTradesPerLogin: boolean;
    PermCloseTradesPerTicket: boolean;
    PermManageARuleReverse: boolean;
    PermAccessSubIB: boolean;
    PermAccessSubIBDetails: boolean;
    PermTransferClient: boolean;
    PermClientOpenOrders: boolean;
    PermManagement: boolean;
    PermBalance: boolean;
    PermCommission: boolean;
    PermReporting: boolean;
    PermSpecialReport: boolean;
    PermClientPersonalDetails: boolean;
    PermPromotion: boolean;
    GCENID: number;
    UserAuthID: string;
    EmailLang: string;
    PermRiskStatementReminder: boolean;
    RiskStatementReminderDesc: string;
}

export interface IUserData {
    id: string;
    Token: string;
    RefreshToken: string;
    isAdmin: boolean;
    isFirstUser: boolean;
    yoonitGetURL: string;
    yoonitActionURL: string;
    TechAPIURL: string;
    CDNURL: string;
    UserName: string;
    Language: string;
    TimeZone: number;
    ZendeskID: string;
}
export interface IPerms {
    PermID: number | null;
    ParentPermID: number | null;
    PermName: string;
    PermValID: number | null;
    PermValName: string;
}
export interface ICompanyData {
    CompanyID: string;
    CompanyName: string;
    CompanyTitle: string;
    SignalRHubURL: string;
    allowpayment: string;
}

export interface LoginAction {
    CompanyAuth: boolean;
    isAuth: boolean;
    isPrimarySalt: boolean;
    isTokenExpired: boolean;
    isTokenValid: boolean;
    UserData: IUserData;
    CompanyData: ICompanyData;
    ClientData: GetClientData;
    AdminData: GetAdminData;
}

export interface IStore {
    history: any;
    router: any;
    sidebar: any;
    theme: any;
    toastr: any;
    auth: LoginAction;
    language: any;
    actionSideBar: any;
    CompanySettings: LoadCompanyLogoResult;
    CompanyData: GetCompanyDataResult;
}

export interface GetClientData {
    BUID: string;
    ClientID: string;
    ContactID: string;
    ContactStatus: string;
    SalutationID: number;
    SalutationTxt: string;
    FirstName: string;
    LastName: string;
    Email: string;
    Phone: string;
    CountryID: number;
    CountryName: string;
    DOB: string;
    ProfileImage: string;
    IsActive: boolean;
    RequireKYC: boolean;
    KYCStatus: string;
    ZipCode: string;
    ResidentialAddress: string;
    City: string;
    KYCReason: string;
    CountryCode: string;
    PoolID: number;
    hasKYC: boolean;
    NmbrOfAcc: number;
    CardValidation: boolean;
    IsValid: boolean;
    KTID: boolean;
    AllowAddDemoAcc: boolean;
    RiskStatementReminder: string;
}

export interface GetAdminData {
    AUID: string;
    ContactID: string;
    ContactStatus: string;
    SalutationID: number;
    SalutationTxt: string;
    FirstName: string;
    LastName: string;
    Email: string;
    Phone: string;
    CountryID: number;
    CountryName: string;
    DOB: string;
    ProfileImage: string;
    IsActive: boolean;
}
